import { render } from "./ModalPrompt.vue?vue&type=template&id=67ce479c&scoped=true"
import script from "./ModalPrompt.vue?vue&type=script&lang=js"
export * from "./ModalPrompt.vue?vue&type=script&lang=js"

import "./ModalPrompt.vue?vue&type=style&index=0&id=67ce479c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ce479c"]])

export default __exports__